import { useState, useCallback } from 'react'

import { TabContext, TableContext } from './useTabContext'

export function TabProvider({ children }) {
  const [currentTabIndex, setCurrentTabIndex] = useState<number>(0)
  const [currentTableIndex, setCurrentTableIndex] = useState<number>(0)

  const handleTabChange = useCallback(
    (_, value: number) => {
      setCurrentTabIndex(value)
    },
    [setCurrentTabIndex],
  )
  const handleTableChange = useCallback(
    (value: number) => {
      setCurrentTableIndex(value)
    },
    [setCurrentTableIndex],
  )

  return (
    <>
      <TabContext.Provider value={{ currentTabIndex, handleTabChange }}>
        <TableContext.Provider value={{ currentTableIndex, handleTableChange }}>
          {children}
        </TableContext.Provider>
      </TabContext.Provider>
    </>
  )
}
